import { render, staticRenderFns } from "./DataMain.vue?vue&type=template&id=10b573dd&scoped=true&"
import script from "./DataMain.vue?vue&type=script&lang=js&"
export * from "./DataMain.vue?vue&type=script&lang=js&"
import style0 from "./DataMain.vue?vue&type=style&index=0&id=10b573dd&scoped=true&lang=css&"
import style1 from "./DataMain.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b573dd",
  null
  
)

export default component.exports